import React from 'react';
import './App.css';
import Banner from './Banner';
import Header from './Header';
import Sidebar from './Sidebar';
import Templates from './Templates';

function App() {
  return (
    <div className="app">
      <Header />
      <Sidebar />
        <main>
          <Banner />
          <Templates
            title="Resumes"
            image_1="https://template.canva.com/EAEfVPChZWs/1/0/309w-B33L3rpwXIE.jpg"
            image_2="https://template.canva.com/EAD7YntQATc/1/0/283w-rgS0NrpC448.jpg"
            image_3="https://template.canva.com/EAEW1CAbEs8/1/0/283w-724Unfzh0Gg.jpg"
            image_4="https://template.canva.com/EAD7WzJh700/1/0/283w-rndS0ehzYnY.jpg"
            image_5="https://template.canva.com/EAD7WSwGy20/1/0/283w-JJOikLI35ys.jpg"
          />
          <Templates
            title="Instagram Posts"
            image_1="https://template.canva.com/EAEg2oqkjtE/1/0/400w-ThdG1DiSMxc.jpg"
            image_2="https://template.canva.com/EAEV4uwzlQE/1/0/400w-YmSzf_xmzq0.jpg"
            image_3="https://template.canva.com/EAEXt2fPsi4/1/0/400w-8rpneVHA3PM.jpg"
            image_4="https://template.canva.com/EAEaWoeP6yY/1/0/400w-L7mK1tpIXms.jpg"
            image_5="https://template.canva.com/EAEdCEvN7ho/2/0/400w-ng6HEHaK4bI.jpg"
          />
          <Templates
            title="YouTube Thumbnails"
            image_1="https://template.canva.com/EAEKiRyt_XA/2/0/400w-J6oSlwoNEic.jpg"
            image_2="https://template.canva.com/EAEKicW6cEI/2/0/400w-aG6mjuuQ9O4.jpg"
            image_3="https://template.canva.com/EAEKiQhAtms/2/0/400w-xGw7JAdvz6w.jpg"
            image_4="https://template.canva.com/EAEKeAjcShQ/2/0/400w-ycYD4tXRwlg.jpg"
            image_5="https://template.canva.com/EAEKdSUFE18/2/0/400w-0mWQRKcpWCU.jpg"
          />
          <Templates
            title="Certificates"
            image_1="https://template.canva.com/EAEiQ_1VZaw/1/0/400w-UBygdr1m81Y.jpg"
            image_2="https://template.canva.com/EAEjYm11COI/1/0/400w-k6IgyIgR9Js.jpg"
            image_3="https://template.canva.com/EADapNz5CMU/1/0/400w-bwksWQEGKps.jpg"
            image_4="https://template.canva.com/EAEjYnvNBW8/1/0/400w-GED5z8-F1vY.jpg"
            image_5="https://template.canva.com/EADaoDa5Sxs/1/0/400w-0QTqv8i9Gow.jpg"
          />
          <Templates
            title="Logos"
            image_1="https://template.canva.com/EAEbpSv89sM/3/0/400w-Vlo8-J9XZII.jpg"
            image_2="https://template.canva.com/EAEgOJPy4-Q/1/0/400w-tnsBb0HKbaM.jpg"
            image_3="https://template.canva.com/EAETvkpBRbI/1/0/400w-paBBoWg29Eo.jpg"
            image_4="https://template.canva.com/EAEepIxTBkQ/1/0/400w-0QVTk6rYt2I.jpg"
            image_5="https://template.canva.com/EAETvfmG73E/1/0/400w-ltwGoWga_1g.jpg"
          />
          <Templates
            title="Invoices"
            image_1="https://template.canva.com/EAETpJ0lmjg/1/0/283w-WU8SC6FRgLY.jpg"
            image_2="https://template.canva.com/EAETpXo7hwY/1/0/283w-JxHydMSzhj8.jpg"
            image_3="https://template.canva.com/EAEW1qsE4XE/2/0/283w-ZU5SsD7TwuI.jpg"
            image_4="https://template.canva.com/EAEW1heWXJk/1/0/283w-tdEE4k0iJE0.jpg"
            image_5="https://template.canva.com/EAETpcctMXo/1/0/283w-49Z9VNtlUIs.jpg"
          />
          <Templates
            title="Newsletter"
            image_1="https://template.canva.com/EADaim8XWAA/1/0/283w-7IZWN0NkkZA.jpg"
            image_2="https://template.canva.com/EADapBl-b8U/1/0/283w-X9qUeiLzvvg.jpg"
            image_3="https://template.canva.com/EAEf8zHWW64/1/0/283w-n0CubHXQFA4.jpg"
            image_4="https://template.canva.com/EADajt2pXxY/1/0/283w-_li-4Wm9DQU.jpg"
            image_5="https://template.canva.com/EADaoySm4lk/1/0/283w-MDWnSdGvu7I.jpg"
          />
          <Templates
            title="Magazine Covers"
            image_1="https://template.canva.com/EADankCeYjw/2/0/309w-IQ-93BeylCQ.jpg"
            image_2="https://template.canva.com/EADao1wzQZY/1/0/309w-9iUKKFdtYz0.jpg"
            image_3="https://template.canva.com/EADao79mP0I/1/0/309w-8oWkrq0D3KM.jpg"
            image_4="https://template.canva.com/EADaoGWSbWY/1/0/309w-HX9rAu7FKZI.jpg"
            image_5="https://template.canva.com/EADajqqMxSE/1/0/309w-vnCOyUcPvcQ.jpg"
          />
          <Templates
            title="Reports"
            image_1="https://template.canva.com/EAEVCY-IFHg/1/0/283w-yydl3N_CuLw.jpg"
            image_2="https://template.canva.com/EAEW2WvBysE/1/0/283w-sgIcfE1rLZY.jpg"
            image_3="https://template.canva.com/EAEW1pq_OEQ/1/0/283w--9nKgyJb0LI.jpg"
            image_4="https://template.canva.com/EAEVCJi4cAo/1/0/283w-eqxE-OItYyM.jpg"
            image_5="https://template.canva.com/EAEW11Mb8Xk/1/0/283w-3BQqd1iF3pc.jpg"
          />
        </main>
    </div>
  );
}

export default App;
